import { createGlobalStyle, css } from 'styled-components';

import themeColors from '@polyai/ui/styles/config/colors';
import type { ColorMapping } from '@polyai/ui/styles/config/colors/defaultTheme';

const CYPRESS = process.env.NEXT_PUBLIC_CYPRESS;

const toKebabCase = (str: string) =>
  str.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);

const GlobalStyle = createGlobalStyle`
  :root {
    ${({ theme }) => {
      const colors = theme.activeColorScheme.colors as ColorMapping;
      return Object.entries(colors)
        .map(([key, value]) => `--${toKebabCase(key)}: ${value};`)
        .join('\n');
    }}
  }

  html {
    scroll-behavior: unset;

    overflow: hidden auto;

    font-family: ${({ theme }) => theme.text.font.body};
    font-display: block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color:  ${themeColors.textPrimary};

    background: ${themeColors.backgroundPage};

    -webkit-tap-highlight-color: transparent; /* for removing the highlight on tap/touch */
  }

  html,
  body {
    height: 100%;
    min-height: 100vh;
  }

  /* remove styles from rsuite-no-reset.min.css */
  body {
    font-family: unset;
    font-size: unset;
    color: unset;
    background-color: unset;
  }

  .skeletonInFlexContainer {
    display: flex;
    flex: 1;
  }

  /* don't display error overlay if it's a cypress test run */
  ${
    CYPRESS &&
    css`
      iframe {
        display: none;
      }
    `
  }

  /* Match Cookiebot blacks to our navbar black (#161617) */
  [id="CybotCookiebotDialog"] {
    background: var(--background-inverse) !important;
  }

  [id="CybotCookiebotDialogBodyButton"] {
    background: var(--background-inverse) !important;
  }

  [id="CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection"] {
    background: var(--background-inverse) !important;
  }

  [id="CybotCookiebotDialogBodyContent"] {
    background: var(--background-inverse) !important;
  }

  [class*="CybotCookiebotScrollContainer"],
  [class*="CybotCookiebotScrollbarContainer"] {
    background: var(--background-inverse) !important;
  }

  /* Hide Cookiebot branding */
  /* stylelint-disable selector-id-pattern, selector-class-pattern */
  a#CybotCookiebotDialogPoweredbyCybot,
  div#CybotCookiebotDialogPoweredByText {
    display: none !important;
  }

  /* Hide the Cookiebot Privacy trigger widget */
  #CookiebotWidget {
    display: none !important;
  }
  /* stylelint-enable selector-id-pattern, selector-class-pattern */

`;

export default GlobalStyle;
